import React from "react";

import {
  FaAnglesLeft,
  FaAngleLeft,
  FaAngleRight,
  FaAnglesRight,
} from "react-icons/fa6";

const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <div>
          Page {currentPage} of {totalPages}
        </div>
        <div>
          <nav aria-label="Page navigation" style={{ backgroundColor: "#fff" }}>
            <ul className="pagination pagination-sm justify-content-end">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link text-dark"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  <FaAnglesLeft />
                </button>
              </li>
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link text-dark"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  <FaAngleLeft />
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === index + 1 ? "dark" : ""
                  }`}
                >
                  <button
                    className="page-link  text-dark"
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link  text-dark"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  <FaAngleRight />
                </button>
              </li>
              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link text-dark"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  <FaAnglesRight />
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};


export default Pagination;
